import Viewport from '../lib/viewport';
import Form from '../lib/form';
import Spinner from '../lib/spinner';
import Popup from '../lib/popup';
import Minicart from './minicart';
import Miniquote from './miniquote';
import Alert from './prd-alert';
import Tooltip from '../lib/tooltip';

const DOC = document;

const CORE = {

	className: 'brtn-product--card-lazy',

	Viewport: null,

	miniCart: null,

	miniQuote: null,

	onElement: function (el, isInViewport) {

		if (!isInViewport) {
			return false;
		}

		if ((('__brtnLazyLoading' in el && el.__brtnLazyLoading))) {
			return true;
		}
		el.__brtnLazyLoading = true;

		$.ajax({
			url: '/ajax/product.php',
			data: {
				action: 'lazy-loading',
				prd: el.dataset.prd,
				cat: el.dataset.cat
			},
			type: 'GET',
			dataType: 'json',
		}).done(function (res) {

			if (typeof res !== 'object' || !('error' in res) || !('content' in res)) {
				return;
			}

			if (res.error != 0 || typeof res.content !== 'string' || !res.content.length) {
				return;
			}
			$(el).html(res.content).removeClass(CORE.className);
			CORE.Viewport = CORE.Viewport.reload();
			CORE.tooltip.refresh();

			Alert();

			Spinner({
				prefix: 'brtn',
				parentNode: el
			});

			Form({
				url: '/ajax/product.php',
				action: 'add',
				classNames: {
					form: 'brtn-product--card__quick-add',
					message: 'brtn-message'
				},
				reloadOnDone: false,
				parentNode: el,
				onDone: function (el, r, options) {

					if (r.error) {
						Popup.setHeader('Connexion requise', true);
						Popup.setBody(r.content);
						Popup.show();
						return;
					}

					if (r.content.type === 'cart') {
						CORE.miniCart.set(r.content.button);
					}

					if (r.content.type === 'quotation') {
						CORE.miniQuote.set(r.content.button);
					}

				}
			});

		});

		return true;

	},

	construct: function () {

		CORE.Viewport = Viewport({
			className: CORE.className,
			onElement: CORE.onElement
		});

		CORE.miniCart = Minicart();
		CORE.miniQuote = Miniquote();
		CORE.tooltip = Tooltip({
			classNames: {
				tooltip: 'brtn-onover',
				button: 'brtn-onover__btn',
				desc: 'brtn-onover__desc'
			}
		});

	}

};

export default CORE.construct;